import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-xs text-foreground-500 tracking-widest uppercase mb-2">探索区域</p>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">
            三大春日胜地
          </h2>
          <p className="mt-3 text-foreground-600 text-sm max-w-xl mx-auto">
            从东亚的樱花古韵，到东南亚的热带花海，再到南亚的雪山花季——三条春色之旅，三种不同的春日体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative rounded-lg overflow-hidden h-80 block"
            >
              <img
                src={cat.image}
                alt={cat.name}
                title={`${cat.name} - 亚洲春色`}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <p className="text-white/70 text-xs mb-1">{cat.region}</p>
                <h3 className="text-xl font-bold text-white mb-2">{cat.name}</h3>
                <p className="text-white/80 text-sm line-clamp-2 leading-relaxed">{cat.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}